import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";
import api, { imgUrl } from "../../lib/api";
import { useTheme } from "../../context/ThemeContext";

export default function Footer() {
  const [settings, setSettings] = useState(null);
  const { theme, content } = useTheme();
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  if (!theme.footer_visible) return null;

  return (
    <footer className="mt-24" style={{ backgroundColor: theme.footer_bg, color: theme.footer_text }} data-testid="site-footer" data-eid="footer-section" data-etype="section">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          {settings?.theme?.logo_url ? (
            <img src={imgUrl(settings.theme.logo_url)} alt={settings.business_name || "Humaira Crafts"} className="h-10 object-contain" data-testid="footer-logo-image" />
          ) : (
            <p className="font-serif text-2xl font-semibold">HUMAIRA <span className="text-gold">CRAFTS</span></p>
          )}
          <p className="text-sm text-[#A3A3A3] mt-4 leading-relaxed" data-eid="footer-text" data-etype="text">
            {content.footer_text}
          </p>
          <p className="text-xs text-[#A3A3A3] mt-4">GSTIN: {settings?.gstin || "—"}</p>
          <div className="flex gap-4 mt-6">
            <a href={settings?.instagram || "#"} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram">
              <Instagram strokeWidth={1.5} size={20} className="hover:text-gold transition-colors duration-300" />
            </a>
            <a href={settings?.facebook || "#"} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook">
              <Facebook strokeWidth={1.5} size={20} className="hover:text-gold transition-colors duration-300" />
            </a>
          </div>
        </div>
        <div>
          <p className="small-caps text-gold mb-6">Shop</p>
          <div className="flex flex-col gap-3 text-sm text-[#A3A3A3]">
            <Link to="/shop" className="hover:text-gold transition-colors duration-300" data-testid="footer-shop">All Products</Link>
            <Link to="/wholesale" className="hover:text-gold transition-colors duration-300" data-testid="footer-wholesale">Wholesale Enquiry</Link>
            <Link to="/track-order" className="hover:text-gold transition-colors duration-300" data-testid="footer-track">Track Order</Link>
            <Link to="/wishlist" className="hover:text-gold transition-colors duration-300" data-testid="footer-wishlist">Wishlist</Link>
          </div>
        </div>
        <div>
          <p className="small-caps text-gold mb-6">Company</p>
          <div className="flex flex-col gap-3 text-sm text-[#A3A3A3]">
            <Link to="/about" className="hover:text-gold transition-colors duration-300" data-testid="footer-about">Our Story</Link>
            <Link to="/contact" className="hover:text-gold transition-colors duration-300" data-testid="footer-contact">Contact Us</Link>
            <Link to="/faq" className="hover:text-gold transition-colors duration-300" data-testid="footer-faq">FAQ</Link>
          </div>
        </div>
        <div>
          <p className="small-caps text-gold mb-6">Contact</p>
          <div className="flex flex-col gap-3 text-sm text-[#A3A3A3]">
            <span className="flex items-center gap-2"><MapPin strokeWidth={1.5} size={16} /> {settings?.address || "Delhi, India"}</span>
            <span className="flex items-center gap-2"><Phone strokeWidth={1.5} size={16} /> {settings?.phone || "—"}</span>
            <span className="flex items-center gap-2"><Mail strokeWidth={1.5} size={16} /> {settings?.email || "—"}</span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#A3A3A3]">
          <p>{content.copyright_text.replace("{year}", new Date().getFullYear())}</p>
          <div className="flex gap-6">
            <Link to="/policies/privacy" className="hover:text-gold transition-colors duration-300" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/policies/returns" className="hover:text-gold transition-colors duration-300" data-testid="footer-returns">Returns & Refunds</Link>
            <Link to="/policies/shipping" className="hover:text-gold transition-colors duration-300" data-testid="footer-shipping">Shipping Policy</Link>
            <Link to="/policies/terms" className="hover:text-gold transition-colors duration-300" data-testid="footer-terms">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
